/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Event_Groups_LabelInputs */



/**
* | output |
* | --- |
* | "Select Event Groups" |
*
* @param {Metadata_Merge_Event_Groups_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_event_groups_label = /** @type {((inputs?: Metadata_Merge_Event_Groups_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Event_Groups_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner les groupes d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisgruppen auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona i gruppi di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите группы мероприятий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar grupos de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择活动组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionar grupos de eventos")
	return /** @type {LocalizedString} */ ("Select Event Groups")
});